// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from "axios"

import App from './App'
import router from './router'

Vue.config.productionTip = false
Vue.use(ElementUI);

// axios全局配置
Vue.prototype.$http = axios
// 配置请求的根路径前缀  
axios.defaults.baseURL = 'http://api.zhij.org.cn'


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js